import apiClient, { extractData } from "./client";

export async function getLeaveRequests(params = {}) {
  const response = await apiClient.get("/leave", { params });
  return extractData(response);
}

export async function getLeave(id) {
  const response = await apiClient.get(`/leave/${id}`);
  return extractData(response);
}

export async function getLeaveHistory(id) {
  const response = await apiClient.get(`/leave/${id}/history`);
  return extractData(response);
}

export async function createLeaveRequest(data) {
  const response = await apiClient.post("/leave", data);
  return extractData(response);
}

export async function approveLeave(id, data = {}) {
  const response = await apiClient.post(`/leave/${id}/approve`, data);
  return extractData(response);
}

export async function rejectLeave(id, data = {}) {
  const response = await apiClient.post(`/leave/${id}/reject`, data);
  return extractData(response);
}

export async function cancelLeave(id) {
  const response = await apiClient.post(`/leave/${id}/cancel`);
  return extractData(response);
}

export async function getLeaveBalance(employeeId) {
  const response = await apiClient.get(`/leave/balance/${employeeId}`);
  return extractData(response);
}

/**
 * HR: grant paid leave entitlement days to ALL / DEPARTMENT / selected EMPLOYEES.
 * @param {{ target: string, departmentId?: string, employeeIds?: string[], leaveType: string, days: number, reason?: string }} data
 */
export async function grantLeaveBalances(data) {
  const response = await apiClient.post("/leave/balances/grant", data);
  return extractData(response);
}

/**
 * HR: grant approved paid leave covering a date range (no balance change).
 * @param {{ target: string, departmentId?: string, employeeIds?: string[], startDate: string, endDate: string, reason: string }} data
 */
export async function grantLeaveDays(data) {
  const response = await apiClient.post("/leave/grant-days", data);
  return extractData(response);
}

/**
 * HR: convert one absence, weekly rest, or leave calendar day to
 * ANNUAL / CASUAL / SICK / UNPAID, or convert an absence day to REST.
 * @param {{ employeeId: string, date: string, leaveType: string, reason?: string }} data
 */
export async function convertLeaveDay(data) {
  const response = await apiClient.post("/leave/convert-day", data);
  return extractData(response);
}
